import { isUpdateAvailable } from './releaseCheck'

export type ForceUpdateDeps = {
  getMyReleaseId: () => string
  getLatestReleaseId: () => Promise<string | null>
  /** 도착지 URL 로 full 네비게이션(문서 전체 로드)해 최신 번들을 받는다 */
  navigate: (destinationUrl: string) => void
  /** 이동 직전 훅 — 사후 토스트 마킹 등 */
  onBeforeReload: () => void
}

// GNB 클릭 시 릴리스가 불일치하면 도착지로 full 네비게이션해 최신 번들을 받는다.
// 현재 위치를 새로고침하면(location.reload) GNB 이동이 무효화되므로, 반드시 "도착지"로 이동한다.
// 버전이 일치하면 아무것도 하지 않고, 호출부(NavLink)의 SPA 이동에 맡긴다.
// 위험 화면 보호는 트리거 지점(GNB 클릭)에 내재한다 — GNB 목적지는 전부 safe 화면이다.
export class ForceUpdateService {
  constructor(private deps: ForceUpdateDeps) {}

  async checkNow(destinationUrl: string) {
    await this.check(
      destinationUrl,
      this.deps.getMyReleaseId(),
      await this.deps.getLatestReleaseId(),
    )
  }

  async check(destinationUrl: string, myReleaseId: string, latestReleaseId: string | null) {
    if (!isUpdateAvailable(myReleaseId, latestReleaseId)) return

    this.deps.onBeforeReload()
    this.deps.navigate(destinationUrl)
  }
}
